export default __webpack_public_path__ + "static/media/location-path.de7212d2.png";